import LegendButton from './LegendButton'
import styles from './Graph.module.css'

export default function GraphLegend({layers, handleClick, margin}) {
    return (
        <div className={styles['h-stack-r']} style={{ marginLeft: margin.left, marginRight: margin.right}}>
            { layers.map((layer,i) => <LegendButton
                key={`legend-${layer.name}-${i}`} 
                name={layer.name} 
                handleClick={handleClick}
                color={layer.color}
                shouldDisplay={layer.display !== 'none'}
                largeMode={layer.display === 'area'}
                onClickData={i}
            /> ) }
        </div>
        )
}